document.addEventListener('DOMContentLoaded', function () {
  // 存储API返回的数据
  let nameData = null;
  // 存储收藏的名字列表
  let favoriteNames = [];
  // loading状态
  let isLoading = false;

  // 初始化图表
  const chartDom = document.getElementById('popularityChart');
  const myChart = echarts.init(chartDom);
  let selectedGender = 'F'; // 默认选择女性

  // 获取h1的标题
  const h1Title = document.querySelector('h1').textContent;
  fetchNameData(h1Title);

  // 获取收藏名字列表
  // fetchFavoriteNames();

  // 初始化收藏按钮
  // initCollectButton();

  // 最顶部的收藏按钮
  // const collectButton = document.getElementById(
  //   'yg-main-container-collect-container-item-save'
  // );
  // if (collectButton) {
  //   collectButton.addEventListener('click', function () {
  //     // 如果正在加载中，不处理点击事件
  //     if (isLoading) return;

  //     // 显示加载状态
  //     const textElement = this.querySelector(
  //       '.yg-main-container-collect-container-item-text'
  //     );
  //     const originalText = textElement.textContent;
  //     textElement.textContent = 'Processing...';
  //     // 移除icon
  //     this.querySelector(
  //       '.yg-main-container-collect-container-item-icon-saved'
  //     ).style.display = 'none';
  //     this.querySelector(
  //       '.yg-main-container-collect-container-item-icon-unsaved'
  //     ).style.display = 'none';
  //     this.classList.add('disabled');

  //     // 获取当前名字
  //     const currentName = document.querySelector('h1').textContent;

  //     // 检查是否已经收藏
  //     const isFavorite = favoriteNames.find(
  //       (item) => item.first_name === currentName && item.middle_name === ''
  //     );

  //     if (isFavorite) {
  //       // 如果已收藏，则取消收藏
  //       YGCustomRequestDelete(
  //         '/my_baby_name_list?baby_name_id=' + isFavorite.id
  //       )
  //         .then((res) => {
  //           if (res.result === 'success') {
  //             // 更新本地收藏列表
  //             favoriteNames = favoriteNames.filter(
  //               (item) =>
  //                 item.first_name === currentName && item.middle_name === ''
  //             );
  //             fetchFavoriteNames();
  //             // 更新UI显示
  //             textElement.textContent = 'Save to List';
  //             this.classList.remove('active');

  //             // 显示成功提示
  //             showToast('Unsaved successfully');
  //             // 移除icon
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-saved'
  //             ).style.display = 'none';
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-unsaved'
  //             ).style.display = 'block';
  //           } else {
  //             // 恢复原始状态
  //             textElement.textContent = originalText;
  //             showToast('Operation failed, please try again');
  //             // 移除icon
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-saved'
  //             ).style.display = 'none';
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-unsaved'
  //             ).style.display = 'block';
  //           }
  //         })
  //         .catch((error) => {
  //           console.error('取消收藏失败:', error);
  //           // 恢复原始状态
  //           textElement.textContent = originalText;
  //           showToast('Network error, please try again');
  //           // 移除icon
  //           this.querySelector(
  //             '.yg-main-container-collect-container-item-icon-saved'
  //           ).style.display = 'none';
  //           this.querySelector(
  //             '.yg-main-container-collect-container-item-icon-unsaved'
  //           ).style.display = 'block';
  //         })
  //         .finally(() => {
  //           // 移除禁用状态
  //           this.classList.remove('disabled');
  //         });
  //     } else {
  //       // 如果未收藏，则添加收藏
  //       YGCustomRequestPost('/my_baby_name_list', {
  //         baby_name: {
  //           first_name: currentName,
  //           middle_name: ''
  //         }
  //       })
  //         .then((res) => {
  //           if (res.result === 'success') {
  //             // 更新本地收藏列表
  //             // favoriteNames.push({
  //             //   first_name: currentName,
  //             //   middle_name: '',
  //             //   id: Date.now().toString()
  //             // });
  //             fetchFavoriteNames();
  //             // 更新UI显示
  //             textElement.textContent = 'Saved';
  //             this.classList.add('active');

  //             // 显示成功提示
  //             showToast('Saved successfully');
  //             // 移除icon
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-saved'
  //             ).style.display = 'block';
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-unsaved'
  //             ).style.display = 'none';
  //           } else {
  //             // 恢复原始状态
  //             textElement.textContent = originalText;
  //             showToast('Operation failed, please try again');
  //             // 移除icon
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-saved'
  //             ).style.display = 'none';
  //             this.querySelector(
  //               '.yg-main-container-collect-container-item-icon-unsaved'
  //             ).style.display = 'block';
  //           }
  //         })
  //         .catch((error) => {
  //           console.error('添加收藏失败:', error);
  //           // 恢复原始状态
  //           textElement.textContent = originalText;
  //           showToast('Network error, please try again');
  //           // 移除icon
  //           this.querySelector(
  //             '.yg-main-container-collect-container-item-icon-saved'
  //           ).style.display = 'none';
  //           this.querySelector(
  //             '.yg-main-container-collect-container-item-icon-unsaved'
  //           ).style.display = 'block';
  //         })
  //         .finally(() => {
  //           // 移除禁用状态
  //           this.classList.remove('disabled');
  //         });
  //     }
  //   });
  // }

  // 初始化主收藏按钮状态
  function updateMainCollectButton() {
    const collectButton = document.getElementById(
      'yg-main-container-collect-container-item-save'
    );
    if (!collectButton) return;

    const currentName = document.querySelector('h1').textContent;
    const isFavorite = favoriteNames.find(
      (item) => item.first_name === currentName && item.middle_name === ''
    );

    if (isFavorite) {
      collectButton.classList.add('active');
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-text'
      ).textContent = 'Saved';
      // 添加收藏图标
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-icon-saved'
      ).style.display = 'block';
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-icon-unsaved'
      ).style.display = 'none';
    } else {
      collectButton.classList.remove('active');
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-text'
      ).textContent = 'Save to List';
      // 移除收藏图标
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-icon-saved'
      ).style.display = 'none';
      collectButton.querySelector(
        '.yg-main-container-collect-container-item-icon-unsaved'
      ).style.display = 'block';
    }
  }

  // 显示提示消息
  function showToast(message) {
    // 检查是否已有toast元素
    let toast = document.querySelector('.yg-toast');
    if (!toast) {
      // 创建toast元素
      toast = document.createElement('div');
      toast.className = 'yg-toast';
      document.body.appendChild(toast);
    }

    // 设置消息并显示
    toast.textContent = message;
    toast.classList.add('show');

    // 3秒后隐藏
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  // 获取名字数据
  function fetchNameData(name) {
    const chartContainer = document.querySelector('.yg-chart-container');
    chartContainer.classList.add('yg-chart-container-loading');
    YGCustomRequestGet('/baby_names_historical_curve', {
      name: name
    })
      .then((res) => {
        if (res.result === 'success' && res.data) {
          nameData = res.data;

          // 设置图表标题
          updateChartTitle();

          // 处理数据并渲染
          processDataAndRender();

          // 初始化年份选择器
          initializeYearSelector();
        } else {
          console.error('接口返回失败:', res);
        }
      })
      .catch((error) => {
        console.error('请求失败:', error);
        chartContainer.classList.remove('yg-chart-container-loading');
      })
      .finally(() => {
        chartContainer.classList.remove('yg-chart-container-loading');
      });
  }

  // 显示加载中效果
  function showLoading() {
    isLoading = true;

    // 处理相似名字区域和兄弟姐妹名字区域
    ['yg-similar-names', 'yg-sibling-names'].forEach((containerId) => {
      const container = document.getElementById(containerId);
      if (!container) return;

      // 为容器添加loading类
      container.classList.add('loading');

      // 检查是否已存在loading spinners
      if (!container.querySelector('.loading-spinner')) {
        // 确保容器有position以便正确定位spinner
        if (getComputedStyle(container).position === 'static') {
          container.style.position = 'relative';
        }

        // 创建loading overlay
        const overlay = document.createElement('div');
        overlay.className = 'yg-loading-overlay';

        // 创建中央loading container
        const spinnerContainer = document.createElement('div');
        spinnerContainer.className = 'yg-loading-container';

        // 创建中央loading spinner
        const centerSpinner = document.createElement('div');
        centerSpinner.className = 'loading-spinner';
        spinnerContainer.appendChild(centerSpinner);

        // 添加加载中文字
        const loadingText = document.createElement('div');
        loadingText.className = 'yg-loading-text';
        spinnerContainer.appendChild(loadingText);

        overlay.appendChild(spinnerContainer);
        container.appendChild(overlay);
      }
    });
  }

  // 隐藏加载中效果
  function hideLoading() {
    isLoading = false;

    // 移除所有容器的loading类
    ['yg-similar-names', 'yg-sibling-names'].forEach((containerId) => {
      const container = document.getElementById(containerId);
      if (container) {
        container.classList.remove('loading');
      }
    });

    // 更新心形图标状态
    if (favoriteNames.length >= 0) {
      highlightFavoriteNames();
    }
  }

  // 请求收藏名字列表
  function fetchFavoriteNames() {
    // 显示加载中效果
    showLoading();

    YGCustomRequestGet('/my_baby_name_list')
      .then((res) => {
        if (res.result === 'success' && res.data) {
          // 存储收藏名字列表
          favoriteNames = res.data.baby_names || [];

          // 高亮已收藏的名字
          highlightFavoriteNames();

          // 更新主收藏按钮状态
          updateMainCollectButton();
        } else {
          console.error('获取收藏名字列表失败:', res);
          // 即使失败也要隐藏loading状态
          hideLoading();
        }
      })
      .catch((error) => {
        console.error('请求失败:', error);
        // 即使出错也要隐藏loading状态
        hideLoading();
      })
      .finally(() => {
        // 确保loading状态被隐藏
        hideLoading();
      });
  }

  // 添加 baby name
  function addBabyName({ first_name, middle_name }) {
    // 显示加载中效果
    showLoading();

    YGCustomRequestPost('/my_baby_name_list', {
      baby_name: {
        first_name,
        middle_name
      }
    })
      .then((res) => {
        if (res.result === 'success') {
          fetchFavoriteNames();
        } else {
          // API调用成功但操作失败，隐藏loading
          hideLoading();
        }
      })
      .catch((error) => {
        console.error('添加收藏请求失败:', error);
        // 出错时隐藏loading
        hideLoading();
      });
  }

  // 删除 baby name
  function deleteBabyName({ baby_name_id }) {
    // 显示加载中效果
    showLoading();

    YGCustomRequestDelete('/my_baby_name_list?baby_name_id=' + baby_name_id)
      .then((res) => {
        if (res.result === 'success') {
          fetchFavoriteNames();
        } else {
          // API调用成功但操作失败，隐藏loading
          hideLoading();
        }
      })
      .catch((error) => {
        console.error('删除收藏请求失败:', error);
        // 出错时隐藏loading
        hideLoading();
      });
  }

  // 更新图表标题
  function updateChartTitle() {
    const genderText = selectedGender === 'F' ? 'Girl' : 'Boy';
    document.querySelector('.yg-chart-title').textContent =
      'Popularity of ' + nameData.name + ' - ' + genderText;
  }

  // 高亮已收藏的名字
  function highlightFavoriteNames() {
    if (!favoriteNames.length && !nameData) return;

    // 当前名字
    const currentName = nameData ? nameData.name : '';

    // 处理相似名字区域（middle_name）
    const similarNamesContainer = document.getElementById('yg-similar-names');
    if (similarNamesContainer) {
      // 移除所有已绑定的事件
      removeAllHeartClickEvents(similarNamesContainer);

      const namePills = similarNamesContainer.querySelectorAll('.yg-name-pill');

      namePills.forEach((pill) => {
        const nameSpan = pill.querySelector('span');
        const nameText = nameSpan ? nameSpan.textContent.trim() : '';

        // 检查是否在收藏列表中（作为middle_name，当前名字作为first_name）
        const isFavorite = favoriteNames.some(
          (item) =>
            item.middle_name === nameText && item.first_name === currentName
        );

        if (isFavorite) {
          updateHeartIcon(pill, true);
        } else {
          updateHeartIcon(pill, false);
        }

        // 添加点击事件
        addHeartClickEvent(pill, nameText, 'middle');
      });
    }

    // 处理兄弟姐妹名字区域（first_name）
    const siblingNamesContainer = document.getElementById('yg-sibling-names');
    if (siblingNamesContainer) {
      // 移除所有已绑定的事件
      removeAllHeartClickEvents(siblingNamesContainer);

      const namePills = siblingNamesContainer.querySelectorAll('.yg-name-pill');

      namePills.forEach((pill) => {
        const nameSpan = pill.querySelector('span');
        const nameText = nameSpan ? nameSpan.textContent.trim() : '';

        // 检查是否在收藏列表中（作为first_name）
        const isFavorite = favoriteNames.some(
          (item) => item.first_name === nameText
        );

        if (isFavorite) {
          updateHeartIcon(pill, true);
        } else {
          updateHeartIcon(pill, false);
        }

        // 添加点击事件
        addHeartClickEvent(pill, nameText, 'first');
      });
    }
  }

  // 移除所有心形图标点击事件
  function removeAllHeartClickEvents(container) {
    if (!container) return;

    const iconContainers = container.querySelectorAll('.yg-name-pill-icon');
    iconContainers.forEach((iconContainer) => {
      // 克隆并替换元素，以移除所有事件监听器
      const newIconContainer = iconContainer.cloneNode(true);
      if (iconContainer.parentNode) {
        iconContainer.parentNode.replaceChild(newIconContainer, iconContainer);
      }
    });
  }

  // 更新心形图标
  function updateHeartIcon(pill, isFavorite) {
    const iconContainer = pill.querySelector('.yg-name-pill-icon');
    if (!iconContainer) return;

    if (isFavorite) {
      // 实心爱心（已收藏）
      iconContainer.innerHTML = `
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.24996 3.38135C3.71866 3.38135 1.66663 5.43339 1.66663 7.96468C1.66663 12.548 7.08329 16.7147 9.99996 17.6839C12.9166 16.7147 18.3333 12.548 18.3333 7.96468C18.3333 5.43339 16.2813 3.38135 13.75 3.38135C12.1998 3.38135 10.8294 4.15089 9.99996 5.32876C9.1705 4.15089 7.80008 3.38135 6.24996 3.38135Z"
            fill="#9C5455" />
        </svg>
      `;
    } else {
      // 空心爱心（未收藏）
      iconContainer.innerHTML = `
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.24996 3.38135C3.71866 3.38135 1.66663 5.43339 1.66663 7.96468C1.66663 12.548 7.08329 16.7147 9.99996 17.6839C12.9166 16.7147 18.3333 12.548 18.3333 7.96468C18.3333 5.43339 16.2813 3.38135 13.75 3.38135C12.1998 3.38135 10.8294 4.15089 9.99996 5.32876C9.1705 4.15089 7.80008 3.38135 6.24996 3.38135Z"
            stroke="#C9837A" stroke-width="1.5" stroke-linejoin="round" />
        </svg>
      `;
    }
  }

  // 添加心形图标点击事件
  function addHeartClickEvent(pill, nameText, nameType) {
    const iconContainer = pill.querySelector('.yg-name-pill-icon');
    if (!iconContainer) return;

    // 确保元素没有之前的点击事件（为安全起见）
    const newIconContainer = iconContainer.cloneNode(true);
    if (iconContainer.parentNode) {
      iconContainer.parentNode.replaceChild(newIconContainer, iconContainer);
    }

    newIconContainer.style.cursor = 'pointer';

    // 使用命名函数以便日后可能的移除
    const clickHandler = function (e) {
      e.preventDefault();
      e.stopPropagation();

      // 检查是否已收藏
      let isFavorite = false;
      let favoriteItem = null;

      if (nameType === 'middle') {
        // 作为中间名，当前名字作为first_name
        favoriteItem = favoriteNames.find(
          (item) =>
            item.middle_name === nameText && item.first_name === nameData.name
        );
        isFavorite = !!favoriteItem;
      } else {
        // 作为first_name
        favoriteItem = favoriteNames.find(
          (item) => item.first_name === nameText
        );
        isFavorite = !!favoriteItem;
      }

      // 切换收藏状态
      if (isFavorite) {
        // 先更新UI，避免多次点击
        updateHeartIcon(pill, false);

        // 安全检查，确保找到了favoriteItem并且有id
        if (favoriteItem && favoriteItem.id) {
          deleteBabyName({
            baby_name_id: favoriteItem.id
          });

          // 从本地列表中移除
          favoriteNames = favoriteNames.filter(
            (item) => item.id !== favoriteItem.id
          );
        } else {
          console.error('未找到要删除的收藏项', nameText, nameType);
          // 重新获取收藏列表以恢复状态
          fetchFavoriteNames();
        }
      } else {
        // 先更新UI，避免多次点击
        updateHeartIcon(pill, true);

        // 添加到本地收藏列表（临时ID，会在获取新列表时更新）
        const tempId = Date.now().toString();
        let newFavorite;

        if (nameType === 'middle') {
          newFavorite = {
            gender: selectedGender === 'F' ? 'girl' : 'boy',
            first_name: nameData.name,
            middle_name: nameText,
            rank: 0,
            id: tempId
          };
          favoriteNames.push(newFavorite);

          addBabyName({
            first_name: nameData.name,
            middle_name: nameText
          });
        } else {
          newFavorite = {
            gender: selectedGender === 'F' ? 'girl' : 'boy',
            first_name: nameText,
            middle_name: '',
            rank: 0,
            id: tempId
          };
          favoriteNames.push(newFavorite);

          addBabyName({
            first_name: nameText,
            middle_name: ''
          });
        }
      }
    };

    // 添加点击事件
    newIconContainer.addEventListener('click', clickHandler);
  }

  // 处理数据并渲染图表
  function processDataAndRender() {
    try {
      // 如果没有数据，尝试自动获取
      if (!nameData) {
        fetchNameData(h1Title);
        return;
      }

      // 处理成我们需要的格式
      const data = [];

      // 处理女性数据
      if (nameData.f_curve_data) {
        if (nameData.f_curve_data.us) {
          data.push({
            name: nameData.name,
            gender: 'F',
            country: 'us',
            ranks: nameData.f_curve_data.us.map((item) => ({
              year: item.year,
              rank: item.rank || 0,
              num: item.num || 0
            }))
          });
        } else {
          // 如果没有US数据，添加一个空数据以保持结构一致
          data.push({
            name: nameData.name,
            gender: 'F',
            country: 'us',
            ranks: []
          });
        }

        if (nameData.f_curve_data.uk) {
          data.push({
            name: nameData.name,
            gender: 'F',
            country: 'uk',
            ranks: nameData.f_curve_data.uk.map((item) => ({
              year: item.year,
              rank: item.rank || 0,
              num: item.num || 0
            }))
          });
        } else {
          // 如果没有UK数据，添加一个空数据以保持结构一致
          data.push({
            name: nameData.name,
            gender: 'F',
            country: 'uk',
            ranks: []
          });
        }
      }

      // 处理男性数据
      if (nameData.m_curve_data) {
        if (nameData.m_curve_data.us) {
          data.push({
            name: nameData.name,
            gender: 'M',
            country: 'us',
            ranks: nameData.m_curve_data.us.map((item) => ({
              year: item.year,
              rank: item.rank || 0,
              num: item.num || 0
            }))
          });
        } else {
          data.push({
            name: nameData.name,
            gender: 'M',
            country: 'us',
            ranks: []
          });
        }

        if (nameData.m_curve_data.uk) {
          data.push({
            name: nameData.name,
            gender: 'M',
            country: 'uk',
            ranks: nameData.m_curve_data.uk.map((item) => ({
              year: item.year,
              rank: item.rank || 0,
              num: item.num || 0
            }))
          });
        } else {
          // 如果没有UK数据，添加一个空数据以保持结构一致
          data.push({
            name: nameData.name,
            gender: 'M',
            country: 'uk',
            ranks: []
          });
        }
      }

      // 没有数据的处理(女生)
      const femaleData = data.filter((item) => item.gender === 'F');
      // 两个的ranks数组都是为空时
      if (
        femaleData.length === 2 &&
        femaleData[0].ranks.length === 0 &&
        femaleData[1].ranks.length === 0
      ) {
        // 给他填上男生的数据，但是都是为0
        femaleData.forEach((item) => {
          item.ranks = JSON.parse(
            JSON.stringify(data.find((item) => item.gender === 'M').ranks)
          );
          item.ranks.forEach((rank) => {
            rank.num = 0;
            rank.rank = 0;
          });
        });
        // 默认选中男生的tab
        document.querySelector('.yg-tab-boy').click();
      }

      // 没有数据的处理（男生）
      const maleData = data.filter((item) => item.gender === 'M');
      // 两个的ranks数组都是为空时
      if (
        maleData.length === 2 &&
        maleData[0].ranks.length === 0 &&
        maleData[1].ranks.length === 0
      ) {
        // 给他填上女生的数据，但是都是为0
        maleData.forEach((item) => {
          item.ranks = JSON.parse(
            JSON.stringify(data.find((item) => item.gender === 'F').ranks)
          );
          item.ranks.forEach((rank) => {
            rank.num = 0;
            rank.rank = 0;
          });
        });
      }

      // 四个都不为空的时候
      if (
        nameData.m_curve_data.us ||
        nameData.m_curve_data.uk ||
        nameData.f_curve_data.us ||
        nameData.f_curve_data.uk
      ) {
        // 输出us女生的number总和
        const usGirlNumber =
          nameData?.f_curve_data?.us?.reduce(
            (acc, item) => acc + item.num,
            0
          ) || 0;

        // 输出uk女生的number总和
        const ukGirlNumber =
          nameData?.f_curve_data?.uk?.reduce(
            (acc, item) => acc + item.num,
            0
          ) || 0;

        // 输出us男生的number总和
        const usBoyNumber =
          nameData?.m_curve_data?.us?.reduce(
            (acc, item) => acc + item.num,
            0
          ) || 0;

        // 输出uk男生的number总和
        const ukBoyNumber =
          nameData?.m_curve_data?.uk?.reduce(
            (acc, item) => acc + item.num,
            0
          ) || 0;

        // 男生总和
        const boyNumber = usBoyNumber + ukBoyNumber;

        // 女生总和
        const girlNumber = usGirlNumber + ukGirlNumber;

        if (boyNumber > girlNumber) {
          document.querySelector('.yg-tab-boy').click();
        } else {
          document.querySelector('.yg-tab-girl').click();
        }
      }

      // 更新全局数据
      window.chartData = data;

      renderChart(data);
    } catch (error) {
      console.error('处理数据错误:', error);
    }
  }

  // 初始化年份选择器
  function initializeYearSelector() {
    const yearSelector = document.getElementById('yearSelector');
    yearSelector.innerHTML = ''; // 清空现有选项

    if (!nameData) return;

    // 确定数据源
    const dataSource =
      selectedGender === 'F' ? nameData.f_curve_data : nameData.m_curve_data;
    if (!dataSource || !dataSource.us || dataSource.us.length === 0) {
      // 如果没有年份数据，禁用选择框
      yearSelector.disabled = true;
      return;
    }

    // 启用选择框
    yearSelector.disabled = false;

    // 获取所有年份
    const years = dataSource.us.map((item) => item.year);
    // 按年份排序并去重
    const uniqueYears = [...new Set(years)].sort((a, b) => b - a); // 降序排列

    // 填充选择器
    uniqueYears.forEach((year) => {
      const option = document.createElement('option');
      option.value = year;
      option.textContent = year;
      yearSelector.appendChild(option);
    });

    // 默认选择最新年份
    if (uniqueYears.length > 0) {
      yearSelector.value = uniqueYears[0];

      // 更新统计数据
      const usData = window.chartData.find(
        (d) => d.country === 'us' && d.gender === selectedGender
      );
      const ukData = window.chartData.find(
        (d) => d.country === 'uk' && d.gender === selectedGender
      );
      updateStats(usData, ukData, uniqueYears[0]);
    } else {
      // 如果没有年份，禁用选择框
      yearSelector.disabled = true;
    }
  }

  // 绘制图表函数
  function renderChart(data) {
    try {
      // 获取所选性别的US和UK数据
      const usData = data.find(
        (d) => d.country === 'us' && d.gender === selectedGender
      );
      const ukData = data.find(
        (d) => d.country === 'uk' && d.gender === selectedGender
      );

      if (!usData) {
        // 没有数据的话全部为0
        usData = {
          ranks: []
        };
      }

      if (!ukData) {
        // 没有数据的话全部为0
        ukData = {
          ranks: []
        };
      }

      // 准备数据
      const usRanks = usData.ranks || [];
      const ukRanks = ukData && ukData.ranks ? ukData.ranks : [];

      // 按年份排序
      usRanks.sort((a, b) => a.year - b.year);
      ukRanks.sort((a, b) => a.year - b.year);

      // 获取所有年份
      const allYears = [
        ...new Set([
          ...usRanks.map((r) => r.year),
          ...ukRanks.map((r) => r.year)
        ])
      ].sort((a, b) => a - b);

      // 准备数据系列
      const usValues = [];
      const ukValues = [];

      allYears.forEach((year) => {
        const usYearData = usRanks.find((r) => r.year === year);
        const ukYearData = ukRanks.find((r) => r.year === year);

        usValues.push([year, usYearData ? usYearData.num : 0]);
        ukValues.push([year, ukYearData ? ukYearData.num : 0]);
      });

      // 更新统计数据
      const currentYear = parseInt(
        document.getElementById('yearSelector').value ||
          allYears[allYears.length - 1]
      );
      updateStats(usData, ukData, currentYear);

      // 图表配置
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          // 文案换行
          formatter: function (params) {
            let result = params[0].axisValue + '<br/>';
            params.forEach((param) => {
              const seriesName = param.seriesName;
              // 在移动端时将United States和United Kingdom换行显示
              const formattedName =
                window.innerWidth <= 768
                  ? seriesName
                      .replace('United States', 'US')
                      .replace('United Kingdom', 'UK')
                  : seriesName;
              result +=
                '<div style="display:flex;align-items:center;">' +
                '<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:' +
                param.color +
                ';margin-right:5px;"></span>' +
                formattedName +
                '<b style="margin-left:5px;">' +
                param.value[1]
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                '</b>' +
                '<br/>';
              result += '</div>';
            });
            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#777',
            fontSize: 12,
            rotate: 45,
            interval: Math.ceil(allYears.length / 15) // 动态调整间隔
          }
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D26163',
              fontSize: 12
            },
            min: 0,
            splitNumber: 3,
            scale: false,
            minInterval: 1 // 最小间隔为1，确保能显示0
          },
          {
            type: 'value',
            position: 'right',
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#488CDC',
              fontSize: 12
            },
            splitLine: {
              show: false
            },
            min: 0,
            splitNumber: 3,
            scale: false,
            minInterval: 1 // 最小间隔为1，确保能显示0
          }
        ],
        series: [
          {
            name: 'United States',
            type: 'line',
            yAxisIndex: 0, // 使用左侧Y轴
            data: usValues,
            symbol: 'none',
            symbolSize: 6,
            sampling: 'average',
            itemStyle: {
              color: '#D26163'
            },
            lineStyle: {
              color: '#D26163',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(203, 133, 137, 0.5)' },
                { offset: 1, color: 'rgba(255, 248, 245, 0.1)' }
              ])
            },
            smooth: false
          },
          {
            name: 'United Kingdom',
            type: 'line',
            yAxisIndex: 1, // 使用右侧Y轴
            data: ukValues,
            symbol: 'none',
            symbolSize: 6,
            sampling: 'average',
            itemStyle: {
              color: '#488CDC'
            },
            lineStyle: {
              color: '#488CDC',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(98, 145, 192, 0.5)' },
                { offset: 1, color: 'rgba(240, 248, 255, 0.1)' }
              ])
            },
            smooth: false
          }
        ]
      };

      // 应用配置
      myChart.setOption(option, true);
    } catch (error) {
      console.error('渲染图表错误:', error);
    }
  }

  // 更新统计数据
  function updateStats(usData, ukData, currentYear) {
    try {
      if (!usData) return;

      // 获取美国当前年份数据
      const usCurrentYearData = usData.ranks.find(
        (r) => r.year === currentYear
      );

      if (!usCurrentYearData) {
        console.warn('找不到该年份的美国数据:', currentYear);
        return;
      }

      // 找到前一年的数据
      const prevYear = currentYear - 1;
      const usPrevYearData = usData.ranks.find((r) => r.year === prevYear);

      // 更新显示的年份
      document.getElementById('currentYearDisplay').textContent = currentYear;
      document.getElementById('prevYearDisplay').textContent = prevYear;

      // 更新排名显示
      document.getElementById('currentRankDisplay').textContent =
        usCurrentYearData.rank ? `#${usCurrentYearData.rank}` : '--';

      // 计算排名变化
      if (usPrevYearData && usCurrentYearData.rank) {
        const rankChange = usPrevYearData.rank - usCurrentYearData.rank;
        const rankChangeElement = document.getElementById('rankChangeDisplay');
        const trendIconContainer =
          document.getElementById('trendIconContainer');

        if (rankChange > 0) {
          // 排名提高 (数字变小)
          rankChangeElement.textContent = `+${rankChange}`;
          trendIconContainer.innerHTML = `
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 37.1667C29.2047 37.1667 36.6666 29.7048 36.6666 20.5C36.6666 11.2953 29.2047 3.83337 20 3.83337C10.7952 3.83337 3.33331 11.2953 3.33331 20.5C3.33331 29.7048 10.7952 37.1667 20 37.1667Z"
                stroke="black" stroke-width="2" stroke-linejoin="round" />
              <path d="M20 28.4166V13.4166" stroke="#3BB438" stroke-width="4" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M27.5 20.9166L20 13.4166L12.5 20.9166" stroke="#3BB438" stroke-width="4"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          `;
        } else if (rankChange < 0) {
          // 排名下降 (数字变大)
          rankChangeElement.textContent = `${rankChange}`;
          trendIconContainer.innerHTML = `
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 37.1667C29.2047 37.1667 36.6666 29.7048 36.6666 20.5C36.6666 11.2953 29.2047 3.83337 20 3.83337C10.7952 3.83337 3.33331 11.2953 3.33331 20.5C3.33331 29.7048 10.7952 37.1667 20 37.1667Z"
                stroke="black" stroke-width="2" stroke-linejoin="round" />
              <path d="M20 13.4166V28.4166" stroke="#FD7B6B" stroke-width="4" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12.5 20.9166L20 28.4166L27.5 20.9166" stroke="#FD7B6B" stroke-width="4"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          `;
        } else {
          // 排名不变
          rankChangeElement.textContent = `0`;
          trendIconContainer.innerHTML = `
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 37.1667C29.2047 37.1667 36.6666 29.7048 36.6666 20.5C36.6666 11.2953 29.2047 3.83337 20 3.83337C10.7952 3.83337 3.33331 11.2953 3.33331 20.5C3.33331 29.7048 10.7952 37.1667 20 37.1667Z"
                stroke="black" stroke-width="2" stroke-linejoin="round" />
              <path d="M13.3333 20.5H26.6666" stroke="#888888" stroke-width="4" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          `;
        }
      } else {
        // 没有前一年数据
        document.getElementById('rankChangeDisplay').textContent = `--`;
        document.getElementById('trendIconContainer').innerHTML = '';
      }
    } catch (error) {
      console.error('更新统计错误:', error);
    }
  }

  // 绑定标签切换事件
  document.querySelectorAll('.yg-tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      document
        .querySelectorAll('.yg-tab')
        .forEach((t) => t.classList.remove('yg-tab-active'));
      this.classList.add('yg-tab-active');
      selectedGender = this.dataset.gender;

      // 更新图表标题
      if (nameData) {
        updateChartTitle();
      }

      if (window.chartData) {
        console.log('🚀 ~ renderChart ~ window.chartData:', window.chartData);
        renderChart(window.chartData);
        initializeYearSelector();
      } else {
        processDataAndRender();
      }
    });
  });

  // 绑定年份选择事件
  document
    .getElementById('yearSelector')
    .addEventListener('change', function () {
      if (!window.chartData) return;

      const currentYear = parseInt(this.value);
      const usData = window.chartData.find(
        (d) => d.country === 'us' && d.gender === selectedGender
      );
      const ukData = window.chartData.find(
        (d) => d.country === 'uk' && d.gender === selectedGender
      );
      updateStats(usData, ukData, currentYear);
    });

  // 窗口大小改变时重绘图表
  window.addEventListener('resize', function () {
    myChart.resize();
  });

  // 初始化收藏按钮
  function initCollectButton() {
    const collectButton = document.getElementById(
      'yg-main-container-collect-container-item-save'
    );
    if (!collectButton) return;

    // 设置初始状态
    collectButton.classList.add('not-initialized');
    collectButton.querySelector(
      '.yg-main-container-collect-container-item-text'
    ).textContent = 'Loading...';

    // 确保有点击区域样式
    collectButton.style.cursor = 'pointer';
  }
});
